import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-icon-cart",
  "use": "icon-icon-cart-usage",
  "viewBox": "0 0 20.7 18.8",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20.7 18.8\" id=\"icon-icon-cart\"><title>资源 41</title><g id=\"icon-icon-cart_图层_2\" data-name=\"图层 2\"><g id=\"icon-icon-cart_图层_1-2\" data-name=\"图层 1\"><circle cx=\"6\" cy=\"17.1\" r=\"1.7\" /><circle cx=\"15.2\" cy=\"17.1\" r=\"1.7\" /><path d=\"M11.5,4.1V3.6H4.4L3.6.7H0v2H2.1l2.2,8.4v.2h.1l.8,3.4H17.5v-2H6.8l-.4-1.4H17.8L18.3,9l-1.7.2A5.1,5.1,0,0,1,11.5,4.1Z\" /><path d=\"M16.6,0a4.1,4.1,0,0,0-4.1,4.1,4.1,4.1,0,1,0,8.2,0A4.1,4.1,0,0,0,16.6,0Zm-.3,6.2L14.2,4.3l.6-.7,1.4,1.2,2.3-2.5.8.7Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-cart.svg
// module id = oxQ3
// module chunks = 72